var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogoTele2Bw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "_\\u0421\\u043B\\u043E\\u0439_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 280 105",
    style: {
      enableBackground: "new 0 0 280 105"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_\\u0421\\u043B\\u043E\\u0439_1-2"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M243.7,0.4c10.5-1.5,20.2,1,26.7,7.2c6,5.7,9,13.6,8.3,21.9c-1.4,15.7-9,28.3-30.3,49l-34.9,1.1 c0,0,24.3-22,33.4-32.7c5.9-7,8.4-14.5,6-19.5c-1.5-3.2-5-4.8-9.3-4.5L243.7,0.4L243.7,0.4z M172.2,12.9v20.4l30.3-3.3V8.6 L172.2,12.9L172.2,12.9z M147.6,105V16.3l20.8-2.9V105L147.6,105L147.6,105z M65.5,27.8V45l22.9-2.5V24.6L65.5,27.8L65.5,27.8z  M46.7,105V30.4l15.9-2.2V105L46.7,105L46.7,105z M0,37v15.2l41.1-4.5V31.2L0,37z M13.1,53.1V105h15.1V51.5L13.1,53.1z M65.5,75.2 V57.7l15-1.3v17.9L65.5,75.2z M65.5,87.8V105h22.9V87.1L65.5,87.8z M172.2,69.4V48.6l19.9-1.7v21.4 C192.1,68.3,172.2,69.4,172.2,69.4z M172.2,84.6V105h30.3V83.7C202.5,83.7,172.2,84.6,172.2,84.6z M94.4,105V23.8l18.1-2.5V105 L94.4,105L94.4,105z M115.8,86.3V105h26.2V85.5C142.1,85.5,115.8,86.3,115.8,86.3z M280,105V81.3l-70.8,1.8V105H280z M210.2,44.9 c-1.2-24.5,8.9-39.6,29.5-43.9v23c-4.3,1.8-8.6,5.1-7.6,19L210.2,44.9L210.2,44.9z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoTele2Bw);
export default __webpack_public_path__ + "static/media/Logo_Tele2_BW.b05e6e3f5d407d00b9a6571e23af704a.svg";
export { ForwardRef as ReactComponent };